import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const PredictionCreate = lazy(() =>
  import("@predictions/PredictionCreateNRO").then((module) => ({
    default: module.PredictionCreateRecommendationNRO,
  }))
);

export const engagementPredictionsNewRecommendationNRO: NavigationRoutingObject = {
  section: "analytics",
  Component: PredictionCreate,
  componentFeatureFlippers: ["predictions_nro_component"],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("predictions-create-recommendation-heading", "Create Recommendation"),
  getDeveloperNavigationAllowed: ({ predictionFeatures }) => {
    return predictionFeatures.recommendations.ENABLED;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/predictions/predictions/:appGroupId",
};
